export default {
  //form
  '请输入': '請輸入',
  '预约信息': '預約信息',
  '查看购物车': '查看購物車',
  '订单确认': '訂單確認',
  
  home: '首頁',
  components: '组件',
  count_to_page: '数字渐变',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown編輯器',
  editor_page: '富文本編輯器',
  icons_page: '自定義圖標',
  img_cropper_page: '圖片編輯器',
  update: '上傳數據',
  join_page: 'QQ群',
  doc: '文檔',
  update_table_page: '上傳CSV文件',
  update_paste_page: '粘貼表格數據',
  multilevel: '多级菜单',
  directive_page: '指令',
  level_1: 'Level-1',
  level_2: 'Level-2',
  level_2_1: 'Level-2-1',
  level_2_3: 'Level-2-3',
  level_2_2: 'Level-2-2',
  level_2_2_1: 'Level-2-2-1',
  level_2_2_2: 'Level-2-2-2',
  excel: 'Excel',
  'upload-excel': '上傳excel',
  'export-excel': '導出excel',
  tools_methods_page: '工具函數',
  drag_list_page: '拖拽列表',
  i18n_page: '多語言',
  modalTitle: '模態框題目',
  content: '這是模態框內容',
  buttonText: '顯示模態框',
  'i18n-tip': '注：僅此頁做了多語言，其他頁面沒有在多語言包中添加語言內容',
  error_store_page: '錯誤收集',
  error_logger_page: '錯誤日誌',
  query: '帶參路由',
  params: '動態路由',
  cropper_page: '圖片裁剪',
  message_page: '消息中心',
  tree_table_page: '樹狀表格',
  
  '注册': '註冊',
  '登录': '登錄',
  '第三方登录': '第三方登錄',
  '全部商品': '全部商品',
  
  '加载中...': '加載中...',
  '商品分类': '商品分類',
  '推荐商品': '推薦商品',
  '查看更多': '查看更多',
  'Read More': '查看更多',
  '更多': '更多',
  
  '综合排序': '綜合排序',
  '价格从低到高': '價格從低到高',
  '价格从高到低': '價格從高到低',
  '价格': '價格',
  '确定': '確定',
  
  '抱歉！暂时还没有商品': '抱歉！暫時還沒有商品',
  '抱歉！出错了...': '抱歉！出錯了...',
  
  '数量': '數量',
  '加入购物车': '加入購物车',
  '加入心愿单': '加入心願單',
  '现在购买': '現在購買',
  '产品信息': '產品信息',
  '该商品暂无内容数据': '該商品暫無內容數據',
  
  '账号': '賬號',
  '账户登录': '帳號登錄',
  '记住密码': '記住密碼',
  '找回密码': '找回密碼',
  '忘记密码': '忘記密碼',
  '返回': '返回',
  '登录中...': '登錄中...',
  '账号或者密码不能为空!': '賬號或者密碼不能為空!',
  
  '注册账号': '註冊賬號',
  '登录账号': '登錄賬號',
  '账号格式不正确': '賬號格式不正確',
  '手机号': '手機號',
  '验证码': '驗證碼',
  '获取验证码': '獲取驗證碼',
  '重新发送': '重新發送',
  '密码': '密碼',
  '重复密码': '重複密碼',
  '我已阅读并同意遵守': '我已閱讀並同意遵守',
  '法律声明': '法律聲明',
  '和': '和',
  '隐私条款': '隱私條款',
  
  '如果您已拥有账号，则可在此': '如果您已擁有賬號，則可在此',
  '登陆': '登陸',
  '注册中...': '註冊中...',
  '邮箱': '郵箱',
  '账号密码不能为空!': '賬號密碼不能為空!',
  '手机号码验证码不能为空!': '手機號碼驗證碼不能為空!',
  '验证码不能为空!': '驗證碼不能為空!',
  '两次输入的密码不相同!': '兩次輸入的密碼不相同!',
  '您未勾选同意我们的相关注册协议!': '您未勾選同意我們的相關註冊協議!',
  '恭喜您，注册成功！赶紧体验吧': '恭喜您，註冊成功！趕緊體驗吧',
  '手机号码格式不正确!': '手機號碼格式不正確!',
  '验证码已发送': '驗證碼已發送',
  
  // 公告
  '公告列表': '公告列表',
  '公告详情': '公告詳情',
  
  // 收索
  '首页': '商城首頁',
  '分类': '分類',
  '搜索': '搜索',
  '预约服务': '預約服務',
  '商城资讯': '商城資訊',
  '搜索结果': '搜索結果',
  '拼命搜索中...': '拚命搜索中...',
  '共为您找到': '共為您找到',
  '款商品信息': '款商品信息',
  '商品细节': '商品細節',
  '抱歉！没有为您找到相关的商品': '抱歉！沒有為您找到相關的商品',
  '立即付款': '立即付款',
  // 用户
  '我的优惠券': '我的優惠券',
  
  // 地址 addressList.vue
  
  '添加收货地址': '添加收貨地址',
  '姓名': '姓名',
  '详细地址': '詳細地址',
  '电话': '電話',
  '默认地址': '默認地址',
  '你还未添加收货地址': '你還未添加收貨地址',
  '添加地址': '添加地址',
  
  // coupon.vue
  '您目前还没有优惠券': '您目前還沒有優惠券',
  // information.vue
  
  // order.vue
  '我的订单': '我的訂單',
  
  '商品操作': '商品操作',
  '实付金额': '實付金額',
  '查看详情': '查看詳情',
  '你还未创建过订单': '你還未創建過訂單',
  '支付审核中': '支付審核中',
  '待发货': '待發貨',
  '待收货': '待收貨',
  '支付失败': '支付失敗',
  
  '付款': '付款',
  '配货': '配貨',
  '出库': '出庫',
  '订单状态': '訂單狀態',
  '配送方式': '配送方式',
  '到店自提': '到店自提',
  '物流配送': '物流配送',
  '取消订单': '取消訂單',
  '您的付款时间还有': '您的付款時間還有',
  '超时后订单将自动取消。': '超時後訂單將自動取消。',
  '已结束': '已結束',
  '订单状态：已支付，待系统审核确认': '訂單狀態：已支付，待系統審核確認',
  '订单状态：已关闭': '訂單狀態：已關閉',
  '您的订单已关闭。': '您的訂單已關閉。',
  '订单状态：已完成': '訂單狀態：已完成',
  '您的订单已交易成功，感谢您的惠顾！': '您的訂單已交易成功，感謝您的惠顧！',
  '商品名称': '商品名稱',
  '应付金额：': '應付金額：',
  '获取该订单信息失败': '獲取該訂單信息失敗',
  '取消失败': '取消失敗',
  
  // 订单
  
  '请在': '請在',
  '24 小时内': '24 小時內',
  '完成支付，超时订单将自动取消。': '完成支付，超時訂單將自動取消。',
  '昵称：': '昵稱：',
  '请输入您的昵称': '請輸入您的昵稱',
  '请选择支付金额': '請選擇支付金額',
  
  '输入金额：': '輸入金額：',
  '请输入您的留言内容': '請輸入您的留言內容',
  '支付方式': '支付方式',
  '订单金额：': '訂單金額：',
  '实际应付金额：': '實際應付金額：',
  '支付中...': '支付中...',
  '其它': '其它',
  '立刻支付': '立刻支付',
  
  '支付成功': '支付成功',
  '总共花费 ': '總共花費',
  ' 元': ' 元',
  '查看订单': '查看訂單',
  '继续选购': '繼續選購',
  
  //
  
  '收货人: ': '收貨人: ',
  '(默认地址)': '(默認地址)',
  '收货地址:': '收貨地址',
  '手机号码: ': '手機號碼: ',
  '新增': '新增',
  '修改': '修改',
  '删除': '刪除',
  '使用新地址': '使用新地址',
  '收货人姓名': '收貨人姓名',
  '手机号码': '手機號碼',
  '收货地址': '收貨地址',
  '设为默认': '設為默認',
  '保存': '保存',
  '管理收货地址': '管理收貨地址',
  '提交订单中...': '提交訂單中...',
  '请选择收货地址': '請選擇收貨地址',
  '非法操作': '非法操作',
  '新增收货地址': '新增收貨地址',
  
  // 购物车  // 購物車
  '操作': '操作',
  '全选': '全選',
  '删除选中的商品': '刪除選中的商品',
  '已选择': '已選擇',
  '共计': '共計',
  '件商品': '件商品',
  '应付总额不含运费': '應付總額不含運費',
  '你的购物车空空如也': '你的購物車空空如也',
  '现在选购': '現在選購',
  '现在结算': '現在結算',
  '缺少所需参数': '缺少所需參數',
  '结算中...': '結算中...',
  '删除失败': '刪除失敗',
  '删除成功': '刪除成功',
  
  //  提交订单  //  提交訂單
  '收货信息': '收貨信息',
  '商品信息': '商品信息',
  '购物清单': '購物清單',
  '小计': '小計',
  '单价': '單價',
  '备注': '備註',
  '请填写备注信息': '請填寫備註信息',
  '使用优惠券': '使用優惠券',
  '商品总价': '商品總價',
  '优惠金额': '優惠金額',
  '运费': '運費',
  '应付总额': '應付總額',
  '可用优惠券': '可用優惠券',
  '折': '折',
  '满': '滿',
  '减': '減',
  '分': '分',
  '可用': '可用',
  '无限制使用': '無限制使用',
  '至': '至',
  '限商品': '限商品',
  '全商品可用': '全商品可用',
  '部分商品可用': '部分商品可用',
  '限商家': '限商家',
  '全商家可用': '全商家可用',
  '部分商家可用': '部分商家可用',
  '立即使用': '立即使用',
  '提交订单': '提交訂單',
  '操作成功': '操作成功',
  '确定要删除吗？': '確定要刪除嗎？',
  '提示': '提示',
  '取消': '取消',
  
  // 优惠券 // 優惠券
  '未使用': '未使用',
  '已使用': '已使用',
  '已过期': '已過期',
  
  // 补充 //補充
  '共': '共',
  '合计': '合計',
  '去购物车': '去購物車',
  '您的购物车竟然是空的': '您的購物車竟然是空的',
  '个人中心': '個人中心',
  '退出': '退出',
  '请输入商品信息': '請輸入商品信息',
  '全部': '全部',
  '待付款': '待付款',
  '评价': '評價',
  '订单号': '訂單號',
  '查看物流': '查看物流',
  '删除订单': '刪除訂單',
  '现在付款': '現在付款',
  '批量评价': '批量評價',
  '确认收货': '確認收貨',
  '订单完成': '訂單完成',
  '待评价': '待評價',
  '订单取消': '訂單取消',
  '确定要取消订单吗？': '確定要取消訂單嗎？',
  '操作成功!': '操作成功!',
  '确定要删除订单吗？': '確定要刪除訂單嗎？',
  '确认收货吗？': '確認收貨嗎？',
  '订单创建': '訂單創建',
  '订单支付': '訂單支付',
  '卖家发货': '賣家發貨',
  '买家确认收货': '買家確認收貨',
  '订单状态：订单取消': '訂單狀態：訂單取消',
  '您的订单已取消。': '您的訂單已取消。',
  '您的订单已提交成功！': '您的訂單已提交成功！',
  '订单状态：待发货': '訂單狀態：待發貨',
  '您的订单已支付成功，请等待商家发货！': '您的訂單已支付成功，請等待商家發貨！',
  '订单状态：待收货': '訂單狀態：待收貨',
  '您的订单已发货，请等待商品到达！': '您的訂單已發貨，請等待商品到達！',
  '订单状态：待评价': '訂單狀態：待評價',
  '您的订单已签收，请评价商品！': '您的訂單已簽收，請評價商品！',
  '商品总计': '商品總計',
  '优惠券': '優惠券',
  '商品优惠金额': '商品優惠金額',
  '应付金额': '應付金額',
  '联系电话': '聯繫電話',
  '配送信息': '配送信息',
  '配送方式': '配送方式',
  '到店自提': '到店自提',
  '线下店铺': '線下店鋪',
  '店铺名称': '店鋪名稱',
  '店铺地址': '店鋪地址',
  '物流配送': '物流配送',
  '快递公司': '快遞公司',
  '快递单号': '快遞單號',
  '订单号：': '訂單號：',
  '物流详情': '物流詳情',
  '商品评分': '商品評分',
  '评价晒单': '評價曬單',
  '分享体验心得，给万千想买的人一个参考': '分享體驗心得，給萬千想買的人一個參考',
  '无': '無',
  '提交': '提交',
  '推荐尺寸': '推薦尺寸',
  '文件上传失败:': '文件上傳失敗:',
  '数量已超过': '數量已超過',
  '个！': '個！',
  '请选择jpg,jpeg,png格式图片！': '請選擇jpg,jpeg,png格式圖片！',
  '上传文件大小不能超过2MB!': '上傳文件大小不能超過2MB!',
  '收货人手机号码': '收貨人手機號碼',
  '省级地区': '省級地區',
  '市级地区': '市級地區',
  '区级地区': '區級地區',
  '月销': '月銷',
  '暂无可用优惠': '暫無可用優惠',
  '配送': '配送',
  '包邮': '包郵',
  '买家自付': '買家自付',
  '请选择规格': '請選擇規格',
  '请填写完整数据': '請填寫完整數據',
  '库存不足': '庫存不足',
  '超出产品库存！': '超出產品庫存！',
  '领取成功！': '領取成功！',
  '兑换成功！': '兌換成功！',
  '已添加到购物车': '已添加到購物车',
  '库存': '庫存',
  '优惠券详情': '優惠券詳情',
  '登录邮箱账号': '登錄郵箱賬號',
  '邮箱格式不正确': '郵箱格式不正確',
  '请到邮箱查收': '請到郵箱查收',
  '请查收': '請查收',
  // todo
  '预约时间': '預約時間',
  '预约项目': '預約項目',
  '预约日期': '預約日期',
  '预约地址': '預約地址',
  '预约状态': '預約狀態',
  '服务详情': '服務詳情',
  '该预约暂无内容数据': '該預約暫無內容數據',
  '确定预约': '確定預約',
  '预约门店': '預約門店',
  '请选择预约到店时间': '請選擇預約到店時間',
  '请选择预约日期': '請選擇預約日期',
  '请选择预约时间': '請選擇預約時間',
  '请选择预约门店': '請選擇預約門店',
  '预约成功': '預約成功',
  '我的预约': '我的預約',
  '待确认': '待確認',
  '已确认': '已確認',
  '已完成': '已完成',
  '店铺': '店鋪',
  '预约号': '預約號',
  '确定要取消预约吗？': '確定要取消預約碼？',
  '获取该预约信息失败': '獲取該預約信息失敗',
  '到店后请出示预约码': '到店後請出示預約碼',
  '发送预约码到手机': '發送預約碼到手機',
  '下单时间': '下單時間',
  '待审核': '待審核',
  '通过': '通過',
  '不通过': '不通過',
  '商城首页': '商城首頁',
  '已领完': '已領完',
  '选择时间': '選擇時間',
  '标题': '標題',
  '产品分类': '產品分類',
  
  '当前积分': '當前積分',
  '累计积分': '累計積分',
  '消费积分': '消費積分',
  '积分日志': '積分日誌',
  '日志内容': '日誌內容',
  '时间': '時間',
  '积分明细': '積分明細',
  '我的积分': '我的積分',
  
  'Stripe支付': 'Stripe支付',
  'Paypal支付': 'Paypal支付',
  '到店支付': '到店支付',
  
  '全部清空': '全部清空',
  '全部已读': '全部已讀',
  '您还没有推送消息': '您還沒有推送消息',
  '暂未登录': '暫未登錄',
  '我的消息': '我的消息',
  '消息中心': '消息中心',
  '已读': '已讀',
  '未读': '未讀',
  '购物车': '購物車',
  
  //  评价
  '好评': '好評',
  '中评': '中評',
  '差评': '差評',
  '有图': '有圖',
  '追加': '追加',
  '好评率': '好評率',
  '匿名用户': '匿名用戶',
  '这个人很懒，什么都没留下~': '這個人很懶，什麼都沒留下~',
  '天后追加': '天後追加',
  '当天追加': '當天追加',
  '暂无评价信息': '暫無評價信息',
  // 缺漏
  '口味': '口味',
  '收货人': '收貨人',
  
  '前往结算': '前往結算',
  '预约列表': '預約列表',
  '立即预约': '立即預約',
  '输入并搜索': '輸入並搜索',
  '规格': '規格',
  '立即结算': '立即結算',
  '继续购物': '繼續購物',
  '注册协议': '註冊協議',
  '条件和条款': '條件和條款',
  '兑换': '兌換',
  '已兑换': '已兌換',
  '领取': '領取',
  '已领取': '已領取',
  '请选择': '請選擇',
  '请选择商品': '請選擇商品',
  '暂无相关订单': '暫無相關訂單',
  
  
  '请输入收货人姓名': '請輸入收貨人姓名',
  '请输入收货人手机号': '請輸入收貨人手機號',
  '请选择收货地区': '請選擇收貨地區',
  '请输入收货地址': '請輸入收貨地址',
  '消耗': '消耗',
  '请输入关键字': '請輸入關鍵字',
  '预约订单详情': '預約訂單詳情',
  '暂无相关消息': '暫無相關信息',
  '我的': '我的',
  '消耗积分': '消耗積分',
  '订单信息': '訂單信息',
  '已核销': '已核銷',
  '未核销': '未核銷',
  '核销码': '核銷碼',
  '复制': '複製',
  '复制成功': '複製成功',
  '复制失败': '複製失敗',
  '共为你找到': '共為你找到',
  "款商品": '款商品',
  "待使用": '待使用',
  '设置为默认地址': '設置為默認地址',
  '总价': '總價',
  '上一页': '上一頁',
  '下一页': '下一頁',
  '资讯分享': '資訊分享',
  '名称': '名稱',
  '请输入您的邮箱': '請輸入您的郵箱',
  '请输入您的手机号码': '請輸入您的手機號碼',
  '消息': '消息',
  '发送成功': '發送成功',
  '发送消息': '發送消息',
  '联系我们': '聯繫我們',
  '分享':'分享',
  '上传凭证': '上傳憑證',
  '已上传凭证': '已上傳憑證',
  '暂未上传凭证': '暫未上傳憑證',
  '创建成功': '創建成功',
  '提示：积分可以用来兑换指定商品': '提示：積分可以用來兌換指定商品',
  '分值明细': '分值明細',
  '可约': '可約',
  '约满': '約滿',
  '请输入评价': '請輸入評價',
  'Fps支付': 'FPS支付',
  'PayMe支付': 'PayMe 支付',
  "返回購物車": "返回購物車",
  "快遞費": '快遞費'
};
